
export default {
  state: {
    apiUrl: 'http://jet-api.au-express.com/home/',
		appId: 'mc12598555',
		appKey: '923126c00c876d83d94c0d722c1e89bc',
  },
  mutations: {
    SET_API_URL: (state, url) => {
      state.apiUrl = url;
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js